module.exports = __webpack_public_path__ + "img/rawk-logo-black.f7dfb7ed.svg";